import { Button, Grid, makeStyles } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { desSeleccionarAfiliado } from '../../actions/afiliado';
import { fetchLocalidades } from '../../actions/cbos/localidades';
import { BannerAfiliado } from '../afiliaciones/BannerAfiliado';
import { Buscador } from '../afiliaciones/Buscador'
import { PanelDatosTurno } from '../turnos/nuevo/PanelDatosTurno';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    rootDatos: {
        flexGrow: 1,
        width: "100%",
        backgroundColor: theme.palette.background.paper,
        padding: 10,
        marginTop: 20
    },
    button: {
        marginTop: theme.spacing(2),
        textAlign: "center"
    }
}));

const SoporteDatosContacto = () => {
    const classes = useStyles();
    const dispatch=useDispatch()
    const { afiliado } = useSelector(state => state.afiliacion)
    const { items: localidades, cargada: listaLocCargada } = useSelector((state) => state.localidades);

    useEffect(() => {
        if (!listaLocCargada) {
            dispatch(fetchLocalidades());
        }
    }, [dispatch, localidades, listaLocCargada]);

    useEffect(()=>{
        if(afiliado.id_afiliado){
            dispatch(desSeleccionarAfiliado())
        }
        // eslint-disable-next-line
    }, [])

    return (
        <div className={classes.root}>
            <Grid container spacing={1} direction="row" justify="center" alignItems="center">
                <Grid item xs={12} md={6}>
                    <Buscador />
                </Grid>
                {
                    afiliado.id_afiliado &&
                    <Grid item xs={12} md={8}>
                        <div className={classes.rootDatos}>
                            <BannerAfiliado turnos={true} />
                            <PanelDatosTurno />
                        </div>
                        <div className={classes.button}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => document.querySelector(`#btnSubmitDatosTurnos`).click()}
                            >
                                Guardar datos
                            </Button>
                        </div>
                    </Grid>
                }
            </Grid>
        </div>
    )
}

export default SoporteDatosContacto
